<div class="modal-header">
    <h2 class="modal-title">Time Category</h2>
</div>
<div class="flex-fill d-flex flex-column">
    <div class="card">
        <div class="card-body">
            <dx-form [formData]="timeCategory" validationGroup="mainValidationGroup">
                <dxi-item dataField="name">
                    <dxi-validation-rule type="required" message="Required"> </dxi-validation-rule>
                </dxi-item>
                <dxi-item dataField="isVisibleToEmployee" editorType="dxCheckBox"></dxi-item>
                <dxi-item dataField="notesRequired" editorType="dxCheckBox"></dxi-item>
            </dx-form>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-danger" [disabled]="processing" (click)="save()">Save</button>
    <button type="button" class="btn btn-success" [disabled]="processing" (click)="close()">Close</button>
</div>
